// Container identity schemes and identification policies — spec §2.7, ADR-0003.
import { z } from "zod";
/** Which combination of GS1 keys makes a container unique for a handling profile. */
export const ContainerIdentityScheme = z.enum(["gtin+lot", "gtin+serial", "gtin+lot+serial", "sscc"]);
/** How eagerly containers get individual identity (§2.7 policy table). */
export const IdentificationPolicy = z.enum([
    "supplier-identity-as-is",
    "lot-as-instance",
    "serial-on-demand",
    "serialise-at-receipt",
    "relabel-everything",
]);
const REQUIRED = {
    "gtin+lot": ["01", "10"],
    "gtin+serial": ["01", "21"],
    "gtin+lot+serial": ["01", "10", "21"],
    sscc: ["00"],
};
/** AIs the scheme needs that the scanned data does not carry (empty = complete). */
export function missingForScheme(scheme, e) {
    return REQUIRED[scheme].filter((ai) => !e.ai[ai]);
}
/**
 * Canonical identity key under a scheme, e.g. "gtin+lot:01=07350034150017;10=L-2026-41".
 * Null when the data lacks a required AI. Keys are what the ledger compares; they are
 * not shown to people (labels and HRI are).
 */
export function identityKey(scheme, e) {
    if (missingForScheme(scheme, e).length > 0)
        return null;
    const parts = REQUIRED[scheme].map((ai) => `${ai}=${e.ai[ai]}`);
    return `${scheme}:${parts.join(";")}`;
}
/** Class-level key (GTIN + lot) used for counted stock regardless of scheme. */
export function classKey(e) {
    if (!e.gtin)
        return null;
    return e.lot ? `class:01=${e.gtin};10=${e.lot}` : `class:01=${e.gtin}`;
}
/**
 * Whether the scanned data can identify an individual container under the scheme
 * (instance level) or only its class.
 */
export function identityLevel(scheme, e) {
    if (identityKey(scheme, e))
        return "instance";
    if (classKey(e))
        return "class";
    return "none";
}
//# sourceMappingURL=scheme.js.map